import type { ReactNode, FC } from 'react';

import { cn } from './cn.js';

export interface EmptyProps {
  children: ReactNode;
  icon?: ReactNode;
  className?: string;
}

/** Пустое состояние списка или карточки. */
export const Empty: FC<EmptyProps> = ({ children, icon, className }) => (
  <div
    className={cn(
      'px-5 py-[60px] text-center text-[13px] text-ink-500',
      className,
    )}
  >
    {icon != null && (
      <div className="mb-2.5 flex justify-center text-ink-300">{icon}</div>
    )}
    {children}
  </div>
);
